import AppDescription from '@nxsys/components/AppDescription';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { IEmailLog } from '@nxsys/types/models/emailLog';
import { Descriptions, Tag } from 'antd';
import React from 'react';

type ViewEmailSettingModalProps = {
  isOpen: boolean;
  toggle: () => void;
  data?: IEmailLog;
};

const ViewEmailSettingModal: React.FC<ViewEmailSettingModalProps> = ({
  isOpen,
  toggle,
  data,
}: ViewEmailSettingModalProps) => {
  const { messages } = useTypedIntl();

  return (
    <AppModalContainer
      title={messages['common.emailSetting']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.close'],
          variant: 'outlined',
          onClick: toggle,
        },
      ]}
      minHeight="200px"
    >
      <AppDescription
        column={1}
        labelStyle={{ width: 216 }}
        bordered={false}
        colon={false}
        size="middle"
        className="mt-[16px]"
      >
        <Descriptions.Item label={messages['common.senderEmailId']}>
          {data?.dataSend?.mailFrom ||
            data?.selfBill?.payrollRef?.companyRef?.emailSender ||
            '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.smtpHost']}>
          {data?.smtpConfig?.smtpHost || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.smtpPort']}>
          {data?.smtpConfig?.smtpPort || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.smtpSecure']}>
          {typeof data?.smtpConfig?.smtpSecure === 'boolean' ? (
            <Tag>
              {data?.smtpConfig?.smtpSecure
                ? messages['common.yes']
                : messages['common.no']}
            </Tag>
          ) : (
            '-'
          )}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.smtpUser']}>
          {data?.smtpConfig?.smtpUser || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={messages['common.smtpPassword']}>
          {data?.smtpConfig?.smtpPassword || '-'}
        </Descriptions.Item>
      </AppDescription>
    </AppModalContainer>
  );
};

export default ViewEmailSettingModal;
